import {
  Pagination as MantinePagination,
  PaginationProps as MantinePaginationProps,
} from "@mantine/core"
import { forwardRef } from "react"

import classes from "./Pagination.module.css"

interface PaginationProps extends MantinePaginationProps {
  total: number
}
export const Pagination = forwardRef<HTMLDivElement, PaginationProps>(
  (props, ref) => {
    return <MantinePagination classNames={classes} {...props} ref={ref} />
  }
)
